var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76215 15.7122L4.85712 19.0908L1.54928 19.1607C0.560726 17.3272 0 15.2294 0 13.0001C0 10.8443 0.524265 8.81147 1.45356 7.02148H1.45427L4.39918 7.56139L5.68922 10.4886C5.41922 11.2758 5.27206 12.1208 5.27206 13.0001C5.27216 13.9543 5.44502 14.8687 5.76215 15.7122Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7727 10.5713C25.922 11.3577 25.9998 12.1698 25.9998 12.9999C25.9998 13.9306 25.902 14.8384 25.7156 15.7142C25.0827 18.6942 23.4291 21.2963 21.1385 23.1377L21.1377 23.137L17.4285 22.9477L16.9035 19.6706C18.4235 18.7792 19.6114 17.3841 20.2371 15.7142H13.2856V10.5713H20.3385H25.7727Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1374 23.1369L21.1381 23.1376C18.9103 24.9283 16.0802 25.9997 12.9995 25.9997C8.04883 25.9997 3.74456 23.2326 1.54883 19.1605L5.76169 15.7119C6.85953 18.6419 9.68596 20.7276 12.9995 20.7276C14.4238 20.7276 15.7581 20.3426 16.9031 19.6705L21.1374 23.1369Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2984 2.99284L17.087 6.44068C15.902 5.69999 14.5012 5.27211 13.0005 5.27211C9.61195 5.27211 6.73266 7.45352 5.68981 10.4886L1.45481 7.02142H1.4541C3.61769 2.85 7.97624 0 13.0005 0C16.1548 0 19.047 1.12359 21.2984 2.99284Z",
    fill: "#F14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.d27660335798f9d1cb1b5fc045210b2c.svg";
export { ForwardRef as ReactComponent };